import React from 'react';
export function LinkIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.41 3.508a4.303 4.303 0 016.081.001 4.302 4.302 0 010 6.082l-4.668 4.668a4.303 4.303 0 01-6.082 0 1 1 0 111.414-1.414 2.303 2.303 0 003.254 0l4.668-4.668a2.303 2.303 0 000-3.254 2.303 2.303 0 00-3.254 0l-.003.003-1.563 1.552a1 1 0 11-1.41-1.42l1.563-1.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.177 9.74a4.303 4.303 0 016.082 0 1 1 0 01-1.414 1.415 2.302 2.302 0 00-3.254 0l-4.668 4.668a2.303 2.303 0 000 3.254 2.303 2.303 0 003.254 0l.003-.003 1.563-1.552a1 1 0 011.41 1.419l-1.562 1.55-.001.001a4.303 4.303 0 01-6.081-.001 4.302 4.302 0 010-6.082L8.177 9.74z"
  }));
}